var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/EntryPartnerConnection/index.tsx";
import React from 'react';
import { Divider, HStack, IconLinkArrow12x24, Stack, Text, VStack } from '@adc/parallax-component-library';
import { Link, Main, TitleActionBar } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const EntryPartnerConnection = () => {
  // TODO: adjust this with correct API field
  const hasPumpPartnerAvailable = Boolean(false);
  const handleAddConnectionClick = () => {
    mediator.publish('router:navigate', '/partner-add-connection');
  };
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "AddConnectionPumpPartner",
    title: i18n.t('AddConnectionPumpPartner.title'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$1",
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    testID: "AddConnectionPumpPartner.subtitle",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }, i18n.t('AddConnectionPumpPartner.subtitle')), /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$2",
    padding: "$5",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "AddConnectionPumpPartner.title",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    color: "$text.100",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 13
    }
  }, i18n.t('AddConnectionPumpPartner.content.connectWithCode.primaryText')), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Link, {
    testID: "Partner.addConnection-btn",
    onPress: handleAddConnectionClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 13
    }
  }, i18n.t('AddConnectionPumpPartner.content.connectWithCode.secondaryText')))), hasPumpPartnerAvailable && /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$4",
    padding: "$4",
    paddingVertical: "$2",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    paddingVertical: "$2",
    onPress: () => null,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "Partner.name",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    color: "$text.100",
    width: "90%",
    numberOfLines: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 15
    }
  }, "Tandem"), /*#__PURE__*/React.createElement(IconLinkArrow12x24, {
    testID: "Partner.arrow-icon",
    color: "$interactive.tertiary.enabled.onColor",
    style: {
      width: 12
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 15
    }
  })))));
};
export default EntryPartnerConnection;